module.exports = __webpack_public_path__ + "img/logo_barliner.4f1572e8.svg";